import { FormOutlined } from '@ant-design/icons';
import { Button, Form, Tag } from 'antd';
import { useScenarioConfigContext } from '../ScenarioConfigContext';
import { useFormikContext } from 'formik';
import { FV } from './share';
import { useEffect, useMemo, useState } from 'react';
import { getSendPointScenariosMap, useGetNewScenario, useGetTitle } from '../PolicyForm/share';
import { DisabledProps } from 'views/Aide/Scenario/TaskForm/share';

function ScenarioConfig({ disabled }: DisabledProps) {
  const { scenarioConfigEnable, scenarioConfigs, editScenarioConfigs } = useScenarioConfigContext();

  const { values } = useFormikContext<FV>();

  const { activityType, activityPrepareFrom, activityPrepareTo, stores, promotionType, items } =
    values;

  const getNewScenario = useGetNewScenario();

  const { t, getTitle } = useGetTitle();

  const enable = scenarioConfigEnable && scenarioConfigs.length > 0 && stores.length > 0;

  const [newScenario, setNewScenario] = useState(false);

  useEffect(() => {
    if (enable) {
      getNewScenario({ stores }).then(setNewScenario);
    }
  }, [enable, stores, getNewScenario]);

  const sendPointScenariosMap = useMemo(() => {
    if (!enable) {
      return undefined;
    }
    return getSendPointScenariosMap(
      {
        activityType,
        activityPrepareFrom,
        activityPrepareTo,
        stores,
        promotionType,
      },
      newScenario,
    );
  }, [
    enable,
    activityType,
    activityPrepareFrom,
    activityPrepareTo,
    stores,
    promotionType,
    newScenario,
  ]);

  const enabledList = useMemo(() => {
    if (!sendPointScenariosMap) {
      return undefined;
    }
    return Object.keys(sendPointScenariosMap).reduce<string[]>((res, sendPoint) => {
      return sendPointScenariosMap[sendPoint].reduce((res, scenarioType) => {
        const target = scenarioConfigs.find(({ scenario }) => {
          return (
            scenario ===
            `${
              activityType === 'LIVE_STREAMING_ACTIVITY' ? 'LIVE_STREAMING_ACTIVITY_' : ''
            }${scenarioType}_${sendPoint}`
          );
        });
        if (target?.enable) {
          res.push(getTitle(sendPoint, scenarioType, { activityType, items }));
        }
        return res;
      }, res);
    }, []);
  }, [sendPointScenariosMap, scenarioConfigs, activityType, items, getTitle]);

  if (!sendPointScenariosMap || !enabledList) {
    return <></>;
  }

  return (
    <Form.Item required label={t('生成话术时机')}>
      {enabledList.length > 0 && <Tag>{enabledList[0]}</Tag>}
      {enabledList.length > 1 && <Tag>{t('knowledge.更多x个', { x: enabledList.length - 1 })}</Tag>}
      <Button
        disabled={disabled}
        type="link"
        icon={<FormOutlined />}
        onClick={() =>
          editScenarioConfigs({
            activityFormValues: values,
            sendPointScenariosMap,
          })
        }
      >
        {t('编辑')}
      </Button>
    </Form.Item>
  );
}

export default ScenarioConfig;
